import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path fill="#008528" d="M10.62 13.527 6.721 9.663 4.32 12.046l6.3 6.247 9.7-9.617-2.403-2.383z" />
    </svg>
);
export default SvgCheck;
